"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Apple = Apple;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function Apple(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EDF0EF"
  }), (0, _core.jsx)("path", {
    d: "M29.323 24.035a4.29 4.29 0 012.042-3.598 4.389 4.389 0 00-3.458-1.87c-1.456-.152-2.866.871-3.608.871-.756 0-1.898-.855-3.127-.83a4.606 4.606 0 00-3.876 2.364c-1.676 2.901-.426 7.166 1.18 9.511.803 1.149 1.741 2.432 2.97 2.386 1.202-.05 1.65-.766 3.102-.766 1.437 0 1.858.766 3.112.737 1.29-.02 2.102-1.153 2.877-2.313a9.5 9.5 0 001.316-2.68 4.145 4.145 0 01-2.53-3.812zM26.956 17.025A4.223 4.223 0 0027.92 14a4.295 4.295 0 00-2.78 1.438 4.018 4.018 0 00-.99 2.913 3.552 3.552 0 002.805-1.326z",
    fill: "#1F2D27"
  }));
}

Apple.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Apple"
};